import defaultJson from './defaultSite.json';

export const DEFAULT_SITE = defaultJson;
